/**
 * Thin monkey-patch on console that buffers the last MAX_ENTRIES lines.
 * Call attach() once before React renders (in main.jsx).
 * Call getLines() to retrieve the buffer for a debug bundle.
 */

const MAX_ENTRIES = 500
const _buffer = []
let _attached = false

const LEVELS = ['log', 'info', 'warn', 'error']

function _ts() {
  return new Date().toISOString().replace('T', ' ').replace('Z', '')
}

function _serialize(args) {
  return args.map(a => {
    if (a === null) return 'null'
    if (a === undefined) return 'undefined'
    if (typeof a === 'object') {
      try { return JSON.stringify(a) } catch { return String(a) }
    }
    return String(a)
  }).join(' ')
}

export function attach() {
  if (_attached) return
  _attached = true
  LEVELS.forEach(level => {
    const orig = console[level].bind(console)
    console[level] = (...args) => {
      if (_buffer.length >= MAX_ENTRIES) _buffer.shift()
      _buffer.push({ ts: _ts(), level: level.toUpperCase(), message: _serialize(args) })
      orig(...args)
    }
  })
}

export function getLines() {
  return [..._buffer]
}
